import { render, staticRenderFns } from "./ExamSubjectMarkPage.vue?vue&type=template&id=59362ce8&scoped=true&"
import script from "./ExamSubjectMarkPage.vue?vue&type=script&lang=js&"
export * from "./ExamSubjectMarkPage.vue?vue&type=script&lang=js&"
import style0 from "./ExamSubjectMarkPage.vue?vue&type=style&index=0&id=59362ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59362ce8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
